import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import React__default from 'react';
import { Selectable, Image } from '@mirohq-internal/website-ui-foundation';

const MenuItem = /*#__PURE__*/ React__default.forwardRef(({ animationType, animationDelay = 0, href, label, media, eventKey = '', selected, onSelect, tabIndex, onBlur }, ref)=>{
    const IMAGE_WIDTH = 44;
    const IMAGE_HEIGHT = 44;
    return jsx("li", {
        role: "menuitem",
        children: jsx(Selectable, {
            ref: ref,
            className: classNames(animationType, 'menu-item text-decoration-none'),
            style: {
                '--animation-delay': animationDelay
            },
            fixedWidth: true,
            href: href,
            eventKey: eventKey,
            selected: selected,
            iconSize: "md",
            defaultIcon: !href ? 'ChevronRight' : undefined,
            onSelect: onSelect,
            size: "sm",
            tabIndex: tabIndex,
            onBlur: onBlur,
            children: jsxs("div", {
                className: "d-flex gap-200",
                children: [
                    media?.url && jsx("div", {
                        style: {
                            width: `${IMAGE_WIDTH}px`,
                            height: `${IMAGE_HEIGHT}px`
                        },
                        className: "rounded-50 border border-image-idle overflow-hidden",
                        children: jsx(Image, {
                            priority: true,
                            className: "align-self-center",
                            alt: label || '',
                            src: media?.url || '',
                            width: IMAGE_WIDTH,
                            height: IMAGE_HEIGHT
                        })
                    }),
                    jsx("div", {
                        className: "text-wrap align-self-center",
                        children: `${label}`.trim()
                    })
                ]
            })
        })
    }, label);
});

export { MenuItem };
